import { PurchaseOrderRecommendation } from '@domain/purchasing/models/PurchaseOrderRecommendation';
import { PurchaseOrderRecommendationDTO } from '../dto/PurchaseOrderRecommendationDTO';
import { ForecastPerWeekMapper } from '../../inventory/mappers/ForecastPerWeekMapper';
import { PurchaseOrderItemMapper } from './PurchaseOrderItemMapper';

export class PurchaseOrderRecommendationMapper {
  static toModel(dto: PurchaseOrderRecommendationDTO): PurchaseOrderRecommendation {
    return {
      item: PurchaseOrderItemMapper.toModel(dto.item),
      inventoryForecast: (dto.inventoryForecast ?? []).map(week => ForecastPerWeekMapper.toModel(week)),
      recommendedQuantity: dto.recommendedQuantity,
      moq: dto.moq
        ? {
            purchasePrice: dto.moq.purchasePrice ? parseFloat(dto.moq.purchasePrice) : undefined,
            value: dto.moq.value ? parseFloat(dto.moq.value) : undefined,
            type: dto.moq.type,
            multiple: dto.moq.multiple ? parseInt(dto.moq.multiple) : undefined,
          }
        : undefined,
    };
  }
}
